<ng-template #defaultLinkTemplate>
    <a [shNavigationLink]="item.navigationLink" [ngClass]="{ '-sh-active': isActive$ | async }" class="sh-navigation__link">
        <svg sh-icon *ngIf="item.icon" [name]="item.icon" [size]="navigationIconSize" class="sh-navigation__link__icon" aria-hidden="true"></svg>
        <span class="sh-navigation__link__label" [title]="item.label">{{ item.label }}</span>
        <sh-badge class="sh-navigation__link__badge" [badge]="item.badge"></sh-badge>
    </a>
</ng-template>

<ng-template #linkWithDropmenuTemplate>
    <details class="sh-navigation__dropmenu" (shClickOutside)="closeSubMenu()" #detailsElement>
        <summary class="sh-navigation__dropmenu__header" [ngClass]="{ '-sh-active': isActive$ | async }">
            <div class="sh-navigation__dropmenu__header-content-wrapper">
                <svg *ngIf="item.icon" sh-icon [name]="item.icon" aria-hidden="true" class="sh-navigation__dropmenu__header__icon"></svg>

                <span class="sh-navigation__dropmenu__header__label" [title]="item.label">
                    {{ item.label }}
                    <sh-badge class="sh-navigation__link__badge" [badge]="item.badge"></sh-badge>
                </span>

                <small *ngIf="isActive$ | async" class="sh-navigation__dropmenu__header__sub-label">
                    <ng-container *ngIf="activeSubActionItemLabel$ | async as subItemLabel">
                        <span class="sh-truncate-text" [title]="subItemLabel">{{ subItemLabel }}</span>
                    </ng-container>
                </small>

                <svg
                    sh-icon
                    *ngIf="!openDropmenuAbove"
                    [size]="dropMenuIconSize"
                    name="angle-down"
                    aria-hidden="true"
                    class="sh-navigation__dropmenu__marker"
                ></svg>
            </div>
        </summary>

        <ul class="sh-navigation__dropmenu__list" [ngClass]="{ '-sh-open-above': openDropmenuAbove }">
            <li *ngFor="let dropmenuItem of item.dropmenuItems" class="sh-navigation__dropmenu__list__item" [title]="dropmenuItem.label">
                <a
                    [shNavigationLink]="dropmenuItem.navigationLink"
                    routerLinkActive="-sh-active"
                    class="sh-navigation__dropmenu__link"
                    (click)="closeSubMenu()"
                >
                    {{ dropmenuItem.label }}
                </a>
            </li>
        </ul>
    </details>
</ng-template>

<ng-container *ngIf="hasDropmenuItems; then linkWithDropmenuTemplate; else defaultLinkTemplate"></ng-container>
